import React from "react";
import PropTypes from "prop-types";
import styles from "./styles/Credits.module.css";
import clsx from "clsx";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import { InputField } from "@components/Input/InputField";
import { SelectField } from "@components/Input/SelectField";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";
// import { TableCustom } from "@components/TableCustom/TableCustom";
// import { myData } from "./DataCredits";
import { useDispatch, useSelector } from "react-redux";
import { addBalanceAction } from "@redux/actions";
import { listMonths } from "@pages/CourseCheckout";

const cardNumRegExp = /^\d+$/;

const validateSchema = Yup.object().shape({
  value: Yup.number().required("Balance is required"),
  fullName: Yup.string().required("Full Name is required"),
  cardNumber: Yup.string()
    .required("Card Number is required")
    .matches(cardNumRegExp, "Card Number is not valid")
    .min(16, "Card Number must be have 16 digits")
    .max(16, "Card Number must be have 16 digits"),
  year: Yup.date()
    .required("Year is required")
    .min(
      moment().year(),
      "Year must be current year or greater than current year"
    ),
  month: Yup.date()
    .required("Month is required")
    .when("year", (year) => {
      if (moment(year).year() === moment().year() && year) {
        return Yup.date()
          .min(
            moment().month() + 1,
            "Month must be current month or greater than current month"
          )
          .required("Month is required")
          .typeError("Month is required");
      }
    }),
  cvc: Yup.string()
    .required("CVC is required")
    .matches(cardNumRegExp, "CVC is not valid")
    .min(3, "CVC must be have 3 characters")
    .max(3, "CVC must be have 3 characters"),
});

const initialValues = {
  value: "",
  fullName: "",
  cardNumber: "",
  month: "",
  year: "",
  cvc: "",
};

const Credits = (props) => {
  // state
  const { addBalance } = useSelector((state) => state.balance);
  const { profile } = useSelector((state) => state.user);

  // variables
  // const columns = [
  //   {
  //     title: "Amount",
  //     dataIndex: "amount",
  //     render: (amount) => {
  //       return <span>{`$${amount}`}</span>;
  //     },
  //   },
  //   {
  //     title: "Credit Method",
  //     dataIndex: "creditMethod",
  //   },
  //   {
  //     title: "Date Processed",
  //     dataIndex: "dateProcessed",
  //     render: (date) => {
  //       return <span>{`${moment(date).format("DD MMM YYYY")}`}</span>;
  //     },
  //   },
  // ];

  // logics before hooks

  // hooks
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    values,
    errors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: validateSchema,
    onSubmit: async (values) => {
      dispatch(
        addBalanceAction({
          data: values,
          resetForm: () => {
            resetForm();
          },
        })
      );
    },
  });

  const dispatch = useDispatch();

  const { width } = useWindowSize();

  // useEffect(() => {
  //   dispatch(getBalanceAction());
  // }, []);

  // logics

  // UI partials

  // effects

  // render
  return (
    <div className={clsx(styles.container)}>
      <div className={clsx(styles.header)}>
        <i className="bi bi-credit-card" />
        Credits
      </div>
      <div
        className={clsx(styles.contentContainer, {
          [styles.contentContainerMobile]: width < 800,
        })}
      >
        <div className={clsx(styles.colLeft)}>
          <div className={clsx(styles.card, styles.cardBalance)}>
            <span className={clsx(styles.titleCard)}>Added Credits</span>
            <hr />
            <div className={clsx(styles.descriptionBalance)}>
              <span
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  color: "#b2b2b2",
                }}
              >
                {`$${profile.data.balance}`}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  color: "#686f7a",
                }}
              >
                via Mastercard
              </span>
            </div>
            <hr />
            <div style={{ fontSize: "13px", color: "#686f7a" }}>
              Your credits will be using on <strong>purchase courses</strong>
            </div>
          </div>
          {/* <div className={clsx(styles.card, styles.cardBalance)}>
            <span className={clsx(styles.titleCard)}>Saved Cards</span>
            <hr />
            <div className={clsx(styles.savedContent)}>
              <img
                src={
                  "https://gambolthemes.net/html-items/cursus_main_demo/images/Mastercard.svg"
                }
                alt="master card"
                className={clsx(styles.imageCard)}
              />
              <span>
                <strong>Added:</strong> 25 Mar 2020
              </span>
            </div>
            <hr />
            <div>
              <Button type="submit" className={clsx("w-100")}>
                <div className={clsx(styles.btnContent)}>
                  <span>Change Card</span>
                </div>
              </Button>
            </div>
          </div> */}
        </div>
        <div className={clsx(styles.colRight)}>
          <Form
            noValidate
            onSubmit={handleSubmit}
            className={clsx(styles.card)}
          >
            <span className={clsx(styles.titleCard)}>Add Credit Balance</span>
            <hr />
            <div className={clsx(styles.addContent)}>
              <Row>
                <Col>
                  <Form.Group className="px-0 mb-3" controlId="value">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Add Balance
                    </Form.Label>
                    <InputField
                      name={"value"}
                      type={"text"}
                      placeholder="0"
                      value={values.value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.value}
                      errorsValue={errors.value}
                      prefix={<i className="bi bi-currency-dollar" />}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="px-0 mb-3" controlId="fullName">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Holder Name
                    </Form.Label>
                    <InputField
                      name={"fullName"}
                      type={"text"}
                      placeholder="Enter Holder Name"
                      value={values.fullName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.fullName}
                      errorsValue={errors.fullName}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="px-0 mb-3" controlId="cardNumber">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Card Number
                    </Form.Label>
                    <InputField
                      name={"cardNumber"}
                      type={"text"}
                      placeholder="Enter Card Number"
                      value={values.cardNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.cardNumber}
                      errorsValue={errors.cardNumber}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="px-0 mb-3" controlId="month">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Expiration Month
                    </Form.Label>
                    <SelectField
                      name={"month"}
                      value={values.month || ""}
                      onChange={(val) => setFieldValue("month", val)}
                      listValue={listMonths}
                      isLoading={false}
                      placeholder={"Month"}
                      error={errors.month}
                      setFieldError={() =>
                        setFieldError("month", "Month is required")
                      }
                      touched={touched.month}
                      setFieldTouched={() => {
                        setFieldTouched("month", true);
                      }}
                      multiple={false}
                      bold={false}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="px-0 mb-3" controlId="year">
                    <Form.Label style={{ fontWeight: "bold" }}>
                      Expiration Year
                    </Form.Label>
                    <InputField
                      name={"year"}
                      type={"text"}
                      placeholder="Year"
                      value={values.year}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.year}
                      errorsValue={errors.year}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="px-0 mb-3" controlId="cvc">
                    <Form.Label style={{ fontWeight: "bold" }}>CVC</Form.Label>
                    <InputField
                      name={"cvc"}
                      type={"text"}
                      placeholder="CVC"
                      value={values.cvc}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      autoComplete="off"
                      touchedValue={touched.cvc}
                      errorsValue={errors.cvc}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <hr />
            <div>
              <Button
                type="submit"
                className={clsx("w-100", styles.buttonContainer)}
                disabled={addBalance.processing}
              >
                {addBalance.processing ? (
                  <Spinner
                    animation="border"
                    className="spinner-border text-secondary"
                  />
                ) : (
                  <div className={clsx(styles.btnContent)}>
                    <span>Add Credit</span>
                  </div>
                )}
                {/* <SpinnerCustom /> */}
              </Button>
            </div>
          </Form>
          {/* <TableCustom
            className={clsx(styles.card)}
            columns={columns}
            dataSource={myData}
            isLoading={false}
          /> */}
        </div>
      </div>
    </div>
  );
};

/* required: display name */
Credits.displayName = "Credits";

/* required: props types */
Credits.propTypes = {};

/* required: default props */
Credits.defaultProps = {};

export { Credits };
